import pickBy from 'lodash/pickBy'
import { fetchIndexName } from './utils'

import search_tabs from './search-tabs.json'
import search_tabs_v5 from './search-tabs-v5.json'


// WARNING: modifying this without also updating $search in shortcuts.js could create problems!
export const stateToRoute = (uiState) => {
  const incomingIndex = Object.keys(uiState)[0]
  const version = incomingIndex.substring(incomingIndex.lastIndexOf('-') + 1)
  const indexUiState = [...Object.entries(uiState)][0][1]
  const state = {}

  state.q = indexUiState.query
  state.p = indexUiState.page

  const index = indexToSortBy(indexUiState, version)

  if (index) {
    state.o = index
  }

  if (indexUiState.configure && indexUiState.configure.filters) {
    // Filters are handled differently than facets
    const tab = (version.startsWith('5') ? search_tabs_v5 : search_tabs).find((tab) => tab.filters === indexUiState.configure.filters)

    if (tab) {
      state.ic = tab.name
    }
  }

  if (indexUiState.toggle) {
    if (indexUiState.toggle.is_free == true) {
      state.m = 'free'
    }

    if (indexUiState.toggle.is_new_in_v6 == true) {
      state.new = 'yes'
    }

    if (indexUiState.toggle.is_sponsored == true) {
      state.sponsored = 'yes'
    }

    if (indexUiState.toggle.is_staff_favorite == true) {
      state.favorites = 'staff'
    }
  }

  if (indexUiState.refinementList) {
    checkAndSetProp(state, 'c', indexUiState.refinementList.categories)
    checkAndSetProp(state, 's', indexUiState.refinementList.style)
    checkAndSetProp(state, 'f', indexUiState.refinementList.family)
    checkAndSetProp(state, 'it', indexUiState.refinementList.visual_tags)
    checkAndSetProp(state, 'ip', indexUiState.refinementList.icon_packs)
  }

  return pickBy(state, (val) => {
    return val !== undefined
  })
}

function checkAndSetProp(state, propName, refinement) {
  if (Array.isArray(refinement) && refinement.length > 0) {
    state[propName] = refinement.map(encodeURIComponent).join(',')
  }
}

function getIconPacks(routeState) {
  if (routeState.ip) {
    return routeState.ip.replace(/[=]/, '')
  } else {
    // Check for old URLs with families (Example: ?f=classic,sharp)
    if (routeState.f) {
      return routeState.f.replace(/[=]/, '')
    }
  }

  return null
}

export const routeToState = (routeState) => {
  const categories = routeState.c ? routeState.c.replace(/[=]/, '') : null
  const style = routeState.s ? routeState.s.replace(/[=]/, '') : null
  const family = routeState.f ? routeState.f.replace(/[=]/, '') : null
  const visualTags = routeState.it ? routeState.it.replace(/[=]/, '') : null
  const iconPacks = getIconPacks(routeState)

  // Filters are not added to the state.

  return {
    [FONTAWESOME.ALGOLIA_V5_SEARCH_INDEX_NAME]: {
      query: routeState.q,
      page: routeState.p,
      sortBy: sortByToIndex(routeState.o, '5'),
      toggle: {
        is_free: routeState.m == 'free',
        is_new_in_v6: routeState.new == 'yes',
        is_sponsored: routeState.sponsored == 'yes',
        is_staff_favorite: routeState.favorites == 'staff'
      },
      refinementList: {
        categories: categories ? categories.split(',') : null,
        style: style ? style.split(',') : null,
        family: family ? family.split(',') : null
      }
    },
    [FONTAWESOME.ALGOLIA_V6_SEARCH_INDEX_NAME]: {
      query: routeState.q,
      page: routeState.p,
      sortBy: sortByToIndex(routeState.o, '6'),
      toggle: {
        is_free: routeState.m == 'free',
        is_new_in_v6: routeState.new == 'yes',
        is_sponsored: routeState.sponsored == 'yes',
        is_staff_favorite: routeState.favorites == 'staff'
      },
      refinementList: {
        categories: categories ? categories.split(',') : null,
        style: style ? style.split(',') : null,
        family: family ? family.split(',') : null,
        visual_tags: visualTags ? visualTags.split(',') : null,
        icon_packs: iconPacks ? iconPacks.split(',') : null,
      }
    }
  }
}

function sortByToIndex(value, version) {
  const baseIndex = fetchIndexName(version)
  switch (value) {
    case 'r':
      return baseIndex + '_ranked'

    case 'a':
      return baseIndex + '_alphabetical'

    case 'v':
      return baseIndex + '_version'

    default:
      return baseIndex
  }
}

function indexToSortBy(indexUiState, version) {
  const baseIndex = fetchIndexName(version)
  const filtered = ('query' in indexUiState && indexUiState.query != null) || hasRefinement(indexUiState) || hasToggleRefinement(indexUiState)

  if (indexUiState.sortBy != undefined) {
    switch (indexUiState.sortBy) {
      case baseIndex + '_ranked':
        return filtered ? 'r' : ''

      case baseIndex + '_alphabetical':
        return 'a'

      case baseIndex + '_version':
        return 'v'
    }
  } else {
    return filtered ? 'r' : ''
  }
}

function hasRefinement(indexUiState) {
  if ('refinementList' in indexUiState) {
    return (
      indexUiState.refinementList.categories != null ||
      indexUiState.refinementList.style != null ||
      indexUiState.refinementList.family != null ||
      indexUiState.refinementList.visual_tags != null ||
      indexUiState.refinementList.icon_packs != null
    )
  } else {
    return false
  }
}

function hasToggleRefinement(indexUiState) {
  if ('toggle' in indexUiState) {
    return indexUiState.toggle.is_free || indexUiState.toggle.is_new_in_v6 || indexUiState.toggle.is_sponsored || indexUiState.toggle.is_staff_favorite
  } else {
    return false
  }
}
